import styled from "styled-components";
import {
  FaEye,
  FaEyeSlash,
} from 'react-icons/fa';

const handleBorderColor = ({borderColor, error}) => {
  if(borderColor === 'success') return '#3c763d'
  if(error || borderColor === 'error') return '#d43f3a'
  return '#eee'
}

export const InputContainer = styled.div`
  width: 100%;
  padding: 8px 0;
`;

export const InputWrapper = styled.div`
  position: relative;
`;
export const Label = styled.label`
  font-weight: bold;
  margin-bottom: 8px;
  margin-left: 4px;
`;

export const InputStyled = styled.input`
  width: 100%;
  border-radius: 8px;
  background-color: #eee;
  padding: 10px;
  border: solid 1px;
  border-color: ${(props) => handleBorderColor(props || '')};
`;

export const ErrorMsg = styled.span`
  color: #d43f3a;
  font-size: 12px;
  margin-left: 4px;
`;

export const EyeIconStyled = styled(FaEye)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

export const EyeIconSlashedStyled = styled(FaEyeSlash)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;